(() => {
  if (document.documentElement.lang.split('-')[0] !== 'nl') return;
  const labels = {"Nous préservons votre vie privée":"Wij respecteren uw privacy","Nous et nos partenaires, y compris Shopify, utilisons des cookies et d'autres technologies pour personnaliser votre expérience, vous montrer des publicités et effectuer des analyses, et nous n'utiliserons pas de cookies ou d'autres technologies à ces fins, sauf si vous les acceptez.":"Wij en onze partners, waaronder Shopify, gebruiken cookies en andere technologieën om uw ervaring te personaliseren, advertenties te tonen en analyses uit te voeren. We gebruiken cookies en andere technologieën voor deze doeleinden alleen als u ermee instemt.","Politique de confidentialité":"Privacybeleid","Accepter":"Accepteren","Déclin":"Weigeren",
    'Avis clients': 'Klantbeoordelingen',
    'Excellent': 'Uitstekend',
    'Très Bien': 'Zeer goed',
    'Trier par': 'Sorteren op',
    'Tout': 'Alle beoordelingen',
    'Plus récent': 'Nieuwste eerst',
    'Plus ancien': 'Oudste eerst',
    'Voir plus': 'Meer bekijken',
    "Voir plus d'avis": 'Meer beoordelingen bekijken',
    "Voir l'attestation de confiance": 'Bekijk het vertrouwenscertificaat',
    'Vérifié, collecté via Certishopping': 'Geverifieerd, verzameld via Certishopping'
  };
  const selector = '.certi-title-vertical, #title-certi, #title-rate, .certi-sorting-option, .certi-sortby, #certi_loadMore, .certi-product-reviews-verifie, .certi-note_site-starter-certi-mobile, .certi-title-note-modal, .certi-modal-badge-review, .certi-count-review-message, .certi-based-note, #bloc-certi a, .Avada-CookiesBar__Header, .Avada-CookiesBar__MessageInner span, .Avada-CookiesBar__PolicyWrapper a, .Avada-CookiesBar_AgreeButtonText, .Avada-CookiesBar_DenyButtonText';
  function translate() {
    document.querySelectorAll('.Avada-CookiesBar__PolicyWrapper a[href="/policies/privacy-policy"]').forEach(a => a.setAttribute('href', '/nl/policies/privacy-policy'));
    document.querySelectorAll(selector).forEach(element => {
      for (const node of element.childNodes) {
        if (node.nodeType !== Node.TEXT_NODE) continue;
        const original = node.nodeValue.trim();
        const count = original.match(/^Basé sur ([\d\s.,]+) avis$/);
        const translated = labels[original] || (count ? 'Gebaseerd op ' + count[1] + ' beoordelingen' : null);
        if (translated) node.nodeValue = node.nodeValue.replace(original, translated);
      }
    });
  }
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; translate(); });
  });
  translate();
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
/* Keep floating app controls clear of the theme's mobile navigation. */
(() => {
  const css = '@media(max-width:767px){#carthike-chat-button-container{bottom:calc(80px + env(safe-area-inset-bottom,0px))!important}}';
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);
  const positionWithdrawal = () => {
    const root = document.getElementById('avada-withdrawal-widget')?.shadowRoot;
    if (!root || root.getElementById('ranieri-mobile-spacing')) return;
    const s = document.createElement('style');
    s.id = 'ranieri-mobile-spacing';
    s.textContent = '@media(max-width:767px){.avada-ww-container--bottom-left,.avada-ww-container--bottom-right{bottom:calc(80px + env(safe-area-inset-bottom,0px))!important}.avada-ww-button{font-size:12px;padding:12px;max-width:220px}}';
    root.appendChild(s);
  };
  positionWithdrawal();
  const observer = new MutationObserver(positionWithdrawal);
  observer.observe(document.body, {childList:true, subtree:true});
  setTimeout(() => { positionWithdrawal(); observer.disconnect(); }, 15000);
})();
